module.exports = __webpack_public_path__ + "img/Icon-edit-blue.c255b57a.svg";